import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LocationContainer from '../../containers/Location';
import FormSelect from "../form/FormSelect";

class LocationSelect extends PureComponent {
	componentDidMount() {
		const { locations, searchLocations } = this.props;
		if (_.isEmpty(locations)) {
			searchLocations();
		}
	}

	render () {
		const { locations, showAll } = this.props;
		if (_.isEmpty(locations)) {
			return (<div>Fetching Locations...</div>);
		}

		let options = locations.map((location) => {
			return {
				value: location.locationId,
				display: location.display,
			}
		});
		options = _.sortBy(options, 'display');

		if (showAll) {
			options.unshift({ value: 'all', display: 'All'})
		}

		return (
			<FormSelect
				{...this.props}
				options={options}
			/>
		);
	}
}

LocationSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,
	showAll: PropTypes.bool,

	classes : PropTypes.object,
	helpText : PropTypes.string,
};

LocationSelect.defaultProps =  {
	label : 'Locations',
	locations: [],
};

export default LocationContainer(LocationSelect);
